import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Art57Section } from '../../ui/Art57Section/Art57Section';
import { FieldDefinition } from '../../../sections/bulkExport/message/fieldDefinition';
import { MatStepper } from '@angular/material/stepper';
import { stepperEnum } from '../../common/enum/bulkExportEnum';
import { BulkUtils } from '../../ui/BulkUtils';
import { SectionService } from '../../service/section-service/section-service';
import { BulkService } from '../../service/bulk-service/bulk.service';
import { BulkOperationSourceEnum } from '../../ui/Node/MedicinalProductsNode/BulkOperationSourceEnum';
import { BulkSection } from '../../ui/Art57Section/BulkSection';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-formly-bulk-export-view',
  templateUrl: './formly-bulk-export-view.component.html',
  styleUrls: ['./formly-bulk-export-view.component.scss']
})
export class FormlyBulkExportViewComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;

  BulkOperationSourceEnum = BulkOperationSourceEnum;

  form = new UntypedFormGroup({});
  model: any;
  fieldDefinition: FieldDefinition;
  currentStepIndex:number = 0;

  title: {
    form: UntypedFormGroup|null;
    fields: FormlyFieldConfig[]|null;
  }[]=[];

  steps: {
    //TO-DO add type as enum
    type: string;
    label: string;
    tooltip: string;
    form: UntypedFormGroup|null;
    fields: FormlyFieldConfig[]|null;
  }[] = [];

  
  constructor(private injector: Injector,
              private confirmationService: ConfirmationService
  ) {
    this.fieldDefinition = new FieldDefinition(this.injector);
    this.injector.get(SectionService).changeBulkUpdatedModel$
      .subscribe(source  => {
        if (source === BulkOperationSourceEnum.EXPORT) {
          this.updateFromSection();
        }
      });
  }

  private updateFromSection(): void {
    const section = this.injector.get(Art57Section).getSelectedSection() as BulkSection;
    this.model = section.criteriaModel;
    this.currentStepIndex = section.selectedStep;
    // do NOT recreate `steps` or `title` here (avoid reassigning arrays that cause DOM re-creation)
  }

  ngOnInit() {
    this.updateFromSection();

    this.title = 
    [{
        form: new UntypedFormGroup({}),
        fields: this.fieldDefinition.title,
      }
    ];

    this.steps = [
      {
        type: 'form',
        label: 'Filters',
        tooltip: 'View the values / options of the filters. The filter is highlighted in blue and marked as selected if a value is chosen. ',
        form: new UntypedFormGroup({}),
        fields: this.fieldDefinition.filters,
      },
      {
        type: 'viewer',
        label: 'Requests',
        tooltip: 'The list of bulk export requests made by the HQ organisation group',
        form: null,
        fields: null
      },
    ];
  }

  onStepChange(event: any) {
    this.currentStepIndex = event.selectedIndex;
    const section = this.injector.get(Art57Section).getSelectedSection() as BulkSection;
    section.selectedStep = this.currentStepIndex;
    this.injector.get(BulkService).notifyStepChange(
      this.currentStepIndex,
      BulkOperationSourceEnum.EXPORT
    );
  }

  getStepIcon(step: number) {
    let iconClass = '';

    switch(step) {
      case stepperEnum.firstStep:
        iconClass = 'bi-funnel';
        break;  
      case stepperEnum.secondStep:
        iconClass = 'bi-file-text';
        break;  
    }

    return iconClass;
  } 

  getActiveFilters(): number{
   const activeWithData = BulkUtils.collectActiveFieldValue(this.model,['filterStatus','hasSelectedData']); 
   const active = BulkUtils.collectActiveFieldValue(this.model,['filterStatus']); 
   return active == activeWithData?activeWithData:-1;
  }

  getFiltersWithData(): number{
   const result = BulkUtils.collectActiveFieldValue(this.model,['hasSelectedData']); 
   return result;
  }

  getStepIConStatus(step: number){
    let iconStatus = 'step-icon-gray';

    switch(step) {
      case stepperEnum.firstStep:
        const activeFilters = this.getActiveFilters();
        iconStatus = activeFilters == 0?'step-icon-gray':activeFilters!==this.getFiltersWithData()?'step-icon-yellow':'step-icon-green';
        break;  
      case stepperEnum.secondStep:
        iconStatus = ((!this.model.requestExecuting) ||this.model.requestExecuting == 0)?'step-icon-gray':'step-icon-blink';
        break;   
    }

    return iconStatus;

  }

  filtersApplied() {
    return BulkUtils.getSelectedCheckboxLabels(this.steps[0].fields as  FormlyFieldConfig[],this.model);
  }

  showFiltesrsApplied(){
        this.confirmationService.confirm({
      header: 'Filters Applied',
      message: '<strong>The following filters has been applied</strong><br><span>' + this.filtersApplied() + '</span><br><br><span>',
      icon: 'pi pi-info-circle',
      rejectVisible: true,
      acceptVisible: false,     // oculta el Accept
      rejectLabel: 'Close',     // renombra el botón
      accept: () => {
        // Do nothing
      },
      reject: () => {
        // do nothing
      }
    });

  }
}
